// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2ELJs","form":"styles_form__xsQJz","button":"styles_button__2ErTU","forgot":"styles_forgot__1Nvzx"};